import {redirect, RouteObject} from 'react-router';

/**
 * The old staff workspace. Its pages moved into /dashboard on 2026-09-21
 * (owner: "I do not need pages under /staff"); these redirects keep old links
 * and bookmarks working, query string included.
 *
 *   /staff, /staff/*       → /dashboard
 *   /staff/my-desk, /my-desk → /dashboard/mydesk
 *   /staff/roster          → /dashboard/roster
 *   /staff/students        → /dashboard/students
 */
const MOVED: Record<string, string> = {
  '/staff/my-desk': '/dashboard/mydesk',
  '/my-desk': '/dashboard/mydesk',
  '/staff/roster': '/dashboard/roster',
  '/staff/students': '/dashboard/students',
};

function moved({request}: {request: Request}) {
  const url = new URL(request.url);
  const path = url.pathname.replace(/\/+$/, '');
  return redirect((MOVED[path] ?? '/dashboard') + url.search);
}

export const staffRoutes: RouteObject[] = [
  {path: 'my-desk', loader: moved},
  {path: 'staff', loader: moved},
  {path: 'staff/*', loader: moved},
];
